import styled from 'styled-components';

type IMarginable = {
  margin?: number | string;
};

export const MobileOnlyContent = styled.div`
  display: block;
  width: 100%;

  // it wouldn't display on Pixel phones when it was switched to Landscape mode
  // this ensures we still get the mobile content on pixel devices in Landscape mode
  @media only screen and (min-width: 820px) and (max-width: 828px) and (min-height: 400px) and (max-height: 415px) {
    display: block;
  }
`;

export const ContentBlock = styled.div<IMarginable>`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: ${props => (props.margin ? props.margin : '1.5rem 0')};
  width: 100%;
`;

export const BarcodeContainer = styled.div`
  border-radius: 0.5rem;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const Heading = styled.h3`
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 1.375rem;
  color: ${Styles.color.white};
  margin: 0;
  text-align: center;
`;

export const SubHeading = styled.h5`
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.normal};
  margin: 0;
  text-align: center;
`;

export const Separator = styled.div<IMarginable>`
  border: solid 1px #000;
  height: 2px;
  opacity: 0.2;
  margin: ${props => (props.margin ? props.margin : '0.5rem 0')};
  width: 100%;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
`;
